module.exports = __webpack_public_path__ + "static/media/alertDB8843.1f420e21.png";